import React from "react";
import LeftText from "./LeftText/LeftText";
import RightText from "./RightText/RightText";

const TextField = () => {
	return (
		<div className="flex sm:space-x-2 flex-col sm:flex-row justify-between w-full mt-5 space-y-6 sm:space-y-0">
			<LeftText />
			<RightText />
		</div>
	);
};

export default TextField;
